import { render } from "./QcLotDetailsPage.vue?vue&type=template&id=233367fd"
import script from "./QcLotDetailsPage.vue?vue&type=script&lang=js"
export * from "./QcLotDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__